import { render, staticRenderFns } from "./crear.vue?vue&type=template&id=48b17144&scoped=true"
import script from "./crear.vue?vue&type=script&lang=js"
export * from "./crear.vue?vue&type=script&lang=js"
import style0 from "./crear.vue?vue&type=style&index=0&id=48b17144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b17144",
  null
  
)

export default component.exports